import { Link, useNavigate } from "react-router-dom";
import React, { useState, Fragment } from "react";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import {
  PlusCircleIcon,
  DocumentDownloadIcon,
} from "@heroicons/react/outline";
import Layout from "./../../components/Layout/Layout";
import UserServices from "../../services/UserServices";
import { useEffect } from "react";
import Paginate from "../../utils/Paginate";
import fire from "./../../utils/Toastr";
import ActionDropdown from "../../components/ActionDropdown";

export default function UserManagement() {
  const navigate = useNavigate();
  const [user, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [pageLength, setPageLength] = useState("");
  const [adminType, setAdminType] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const listAllUsers = async (searchParam = search) => {
    const details = await UserServices.listUser(pageIndex, 10, searchParam);

    setUsers([...details.data.result]);
    setPageLength([...details.data.result].length);
    setPageNumber(details.data.totalCount);
    setPageIndex(details.data.pageIndex);
    setPrev(details.data.hasPreviousPage);
    setPage(details.data.totalPages);
    setNextPage(details.data.hasNextPage);
  };

  const listUser = async () => {
    listAllUsers(search);
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  };

  const searchUser = async (text) => {
    setSearch(text);
  };
  const disactivate = async (username) => {
    const resp = await UserServices.disableUser({
      userName: username,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };
  const activate = async (username) => {
    const resp = await UserServices.activateUser({
      userName: username,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };
  const searchUsers = async () => {
    listAllUsers(search, adminType);
  };

  const exportCSV = async () => {
    if (isExporting) return;

    setIsExporting(true);
    try {
      const resp = await UserServices.exportList(search, adminType);
      if (resp.data && typeof resp.data === "string") {
        fire("success", resp.message);
        window.open(resp.data, "_blank");
      } else {
        fire("error", "Export failed. Invalid file URL.");
      }
    } catch (error) {
      fire("error", "An error occurred while exporting.");
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    listUser();
  }, [pageIndex]);
  return (
    <>
      <Layout title="User Management" pageTag={"admin"} current={"/users"}>
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex">
                    <div className="flex">
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <SearchIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        </div>
                        <input
                          type="text"
                          name="user"
                          id="user"
                          onChange={(e) => searchUser(e.target.value)}
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                          placeholder="Search users"
                        />
                        <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                          <div className="tooltip">
                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                            <span className="tooltiptext">
                              {" "}
                              <p>
                                Search by first name,surname, role name , email
                                address and username
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mt-1 ml-4">
                        <button
                          onClick={searchUsers}
                          className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none flex gap-2">
                    <div className=" ml-4 justify-end">
                      <button
                        type="button"
                        onClick={exportCSV}
                        className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                      >
                        <DocumentDownloadIcon className="w-4 mr-1.5" />
                        Export CSV
                      </button>
                    </div>
                    <Link to="/create/user">
                      <button
                        type="button"
                        className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                      >
                        <PlusCircleIcon className="w-4 mr-1.5" />
                        Create New user
                      </button>
                    </Link>
                  </div>
                </div>
                {user.length === 0 ? (
                  <div className="mt-8">
                    {" "}
                    No data available for these dates to show.{" "}
                  </div>
                ) : (
                  <>
                    <div className="mt-8 flex ">
                      <div className="-my-2 -mx-4 overflow-x-auto ">
                        <div className="inline-block min-w-full py-2 align-middle">
                          <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400"
                                  >
                                    Username
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-2 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Role Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Email
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Locked
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Last Modified by
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  ></th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    <span className="sr-only">Edit</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {user.map((person, i) => (
                                  <tr key={i} className="bg-gray-50">
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.userName}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.roleName}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.emailAddress}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.isActive === true
                                        ? "Active"
                                        : "Inactive"}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.isLocked === false
                                        ? "Not Locked"
                                        : "Locked"}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.modifiedBy === ""
                                        ? "N/A"
                                        : person.modifiedBy}
                                    </td>
                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      <ActionDropdown
                                        items={[
                                          { label: "View User", onClick: () => navigate(`/user/view?id=${person.userName}`) },
                                          ...(person.isActive
                                            ? [{ label: "Disable User", onClick: () => disactivate(person.userName) }]
                                            : []),
                                          ...(!person.isActive
                                            ? [{ label: "Activate User", onClick: () => activate(person.userName) }]
                                            : []),
                                          ...(adminType.toLowerCase() === "checker"
                                            ? [{ label: "Edit User", onClick: () => navigate(`/update/user?id=${person.userName}`) }]
                                            : []),
                                        ]}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Paginate
                      nextPage={nextPage}
                      pageIndex={pageIndex}
                      totalCount={pageNumber}
                      totalPages={totalPage}
                      prevPage={prevPage}
                      setPageIndex={setPageIndex}
                    />
                  </>
                )}
              </div>
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
